import React, { useEffect, useRef, useState } from "react";

interface TruncateTextProps {
  text: string;
  lines?: number;
}

const TruncateText: React.FC<TruncateTextProps> = ({ text, lines = 3 }) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight + 1);
    }
  }, [text, lines]);

  return (
    <div className="relative leading-snug">
      <div
        ref={containerRef}
        className={`${
          expanded
            ? "block"
            : `overflow-hidden text-ellipsis line-clamp-${lines}`
        }`}
      >
        {text}
      </div>

      {!expanded && isTruncated && (
        <button
          onClick={() => setExpanded(true)}
          className="absolute bottom-0 right-0 pl-1 bg-white text-blue-600 font-medium cursor-pointer"
        >
          ...More
        </button>
      )}

      {expanded && (
        <button
          onClick={() => setExpanded(false)}
          className="mt-1 text-blue-600 font-medium cursor-pointer bg-transparent border-none"
        >
          ...Less
        </button>
      )}
    </div>
  );
};

export default TruncateText;
